import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Inject } from '@angular/core';
import { get, set, includes } from 'lodash';
import { ICloseReturnType, PlaceholderChildComponent } from '@ispm/layout/classes/placeholder-child-component.abstract';
import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { IEvent, IEventDefinition,TimelineEventActions } from '@ispm-client/modules/events/Interfaces';
import { EventService } from '@ispm-client/modules/events/services/event.service';
import { InterpolateService } from '@ispm/shared/services/interpolate.service';
import {RouterManagerService} from '@ispm/core/services/router-manager.service';
import { EmitterTypes } from '@ispm/layout/constants/emitter-types.enum';
import { EmitType } from '@ispm/layout/constants/emit-types.enum';
import {PlaceholderModalComponent} from "@ispm/layout/components/modals/placeholder-modal/placeholder-modal.component";
import {PlaceholderModalLoaderPayload} from "@ispm/layout/classes/placeholder-modal-loader-payload";
import moment from 'moment';
import {GalleryViewerComponent} from "@ispm-client/modules/file-module/components/gallery-viewer/gallery-viewer.component";
import {ModalTypes} from "@ispm/layout/components/modals/contants/modal-types.enum";
import {DynamicModalLoaderService} from "@ispm/layout/services/dynamic-modal-loader.service";
import {AgregationService, WorkflowUtilService} from "@ispm-client/modules/aggregator/services";
import {EMPTY, Observable} from "rxjs";
import {TimelineService} from "@ispm-client/modules/timeline/services/timeline.service";
import { PermissionSchemaConstants } from '@ispm/shared/constants/permission-schema.constants';
import { map } from 'rxjs/operators';
import { IOptellumConfig } from '../../interfaces/timeline.interface';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import {Router} from "@angular/router";
import { PacsLauncherService } from '@ispm-client/modules/pacs-launcher/services/pacs-launcher.service';

@Component({
  selector: 'ispm-timeline-event-information',
  templateUrl: './timeline.event.information.component.html',
  styleUrls: ['./timeline.event.information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('TimelineEventInformation')
export class TimelineEventInformationComponent extends PlaceholderChildComponent implements OnInit, IWidgetItem {
  pdfFileNotUploaded: boolean;
  showPdfViewer: boolean;
  data: IEvent;
  config: IEventDefinition;
  externalLinks: any;
  minimalFormId: any;
  actions: any;
  fileReferences: any;
  videoFileReferences: any = [];
  imageFileReferences: any = [];
  dicomImageReferences: any = [];
  dicomVideoReferences: any = [];
  videoThumbnailConfiguration: any = { };
  imageThumbnailConfiguration: any = { };
  permitOptellumContextLaunch$: Observable<boolean> = EMPTY;
  hasAppNameAndCtInfo$: Observable<boolean> = EMPTY;
  optellumURL$: Observable<string> = EMPTY;
  optellumButtonLabel$: Observable<string> = EMPTY;
  private optellumInfo: IOptellumConfig;
  public pacsIntegrationAvailable: boolean;

  /**
   * set timeline event config
   * @param widgetData
   */
  set widgetData(widgetData: any) {
    this.data = widgetData;
  }

  set widgetConfig(config: any) {
    this.payload = config.widgetPayload;
  }

  constructor(private _eventService: EventService,
              private router: Router,
              private routerManagerService: RouterManagerService,
              private aggregator: AgregationService,
              private _interpolateService: InterpolateService,
              private workflow: WorkflowUtilService,
              private _modalLoader: DynamicModalLoaderService,
              private _changeDetector: ChangeDetectorRef,
              private _routerManagerService: RouterManagerService,
              private authService: AuthenticationService,
              private timelineService: TimelineService,
              private _pacsLauncherService: PacsLauncherService) {
    super();
  }

  ngOnInit(): void {
    if (this.payload) {
      this.data = get(this.payload, 'data');
      this.config = get(this.payload, 'config');
      this._pacsLauncherService.init().then(() => {
        this.pacsIntegrationAvailable = this._pacsLauncherService.getPacsVisibilityStatus(this.data);
        this._changeDetector.detectChanges();
      });
    }

    this.validateOptellumLaunchURL();
    this.prepareAndMapContentDataWithDefinition();
  }

  /**
   * Prepare event content data and map with respective event definition
   */
  prepareAndMapContentDataWithDefinition() {
    this.minimalFormId = get(this.config, `ui.timeline.minimalFormId`);
    const content: any = get(this.data, 'content');
    this.actions = get(this.config, `ui.timeline.actions`);
    this.externalLinks = content.filter(item => get(item, 'contentType') === 'link')
      .map(item => get(item, 'data'));
    this.fileReferences = content.filter(item => get(item, 'contentType') === 'file');
    // Forming the Data for DIACOM image, As these are the direct WADO URL attaching the fileType to render
    this.dicomImageReferences = content.filter(item => get(item, 'fileType') === 'image' && get(item, 'resourceType') === 'DICOM');
    this.dicomVideoReferences = content.filter(item => get(item, 'fileType') === 'video' && get(item, 'resourceType') === 'DICOM');
    const queries = [];
    if (this.actions && this.fileReferences && this.fileReferences.length > 0) {
      this.fileReferences.forEach(function (file, index) {
        queries.push({
          'targetResource': get(file, 'resourceType'),
          'queryString': `_id=${get(file, 'reference')}`,
          'identifier': `response`
        });
      }.bind(this));
      const fileList = [];
      this.aggregator.registerQuery( queries).subscribe(val => {
        if (val && val.length > 0) {
          val.forEach((fileMeta, index) => {
            let fileData = get(fileMeta, 'response');
            if(fileData) {
              fileData['id'] = get(this.fileReferences, `[${index}].reference`)
              fileList.push({...fileData, ...this.fileReferences[index]});
              if( includes (['gif', 'png', 'jpeg', 'tiff', 'jpg'], fileData.fileType.toLowerCase())){
                this.imageFileReferences.push({...fileData, ...this.fileReferences[index]});
              }
              else if( includes (['mp4', 'mov', 'avi', 'flv'], fileData.fileType.toLowerCase())){
                this.videoFileReferences.push({...fileData, ...this.fileReferences[index]});
              }
            }
          });
          this._changeDetector.detectChanges();
          this._changeDetector.markForCheck();
        }
      });

    }
  }

  /**
   * Navigate to events panel page for more details of event
   */
  navigateToReport() {
    this.tunnel$.next({ emitter: EmitterTypes.child, value: EmitType.Dismiss, payload: { }});
    this._eventService.setSelectedEvent(this.data);
    this.goToState('/Pancancer/$(data.patientId)/reports', this.routerManagerService.parameters);

  }


  /**
   * On Action Click
   */

  onActionClick(action: any) {
    switch (action.action) {
      case TimelineEventActions.EVENT_PANEL:
        this.navigateToReport();
        break;
      case TimelineEventActions.IMAGES_PANEL:set
        const imageAction = this.actions.filter(action => action.action === 'open_images');
        const mergeImageData = [].concat(this.imageFileReferences, this.dicomImageReferences);
        this.imageThumbnailConfiguration = imageAction[0].thumbnailConfiguration;
        this.showImageGallery(action, { data: mergeImageData, thumbnailConfiguration: this.imageThumbnailConfiguration}, 'image');
        break;
      case TimelineEventActions.VIDEOS_PANEL:
        const videoAction = this.actions.filter(action => action.action === 'open_videos');
        const mergeVideoData = [].concat(this.videoFileReferences, this.dicomVideoReferences);
        this.videoThumbnailConfiguration = videoAction[0].thumbnailConfiguration;
        this.showImageGallery(action, { data: mergeVideoData, thumbnailConfiguration: this.videoThumbnailConfiguration}, 'video');
        break;
      case TimelineEventActions.CONTEXT_LAUNCH:
        this.timelineService.launchContextURL(true);
        break;
    }
  }

  /**
   * This method validates configuration in order to display the optellum button
   * Optellum launch permission must be assigned to logged in practitioner
   * Patient must be assigned to logged in practitioner
   * Optellum URL must be configured in server configuration
   * Listed CT event must be able to see the optellum button
   * Patient must can be referred from Incidental and PNC have privilege to launch Optellum
   */
  validateOptellumLaunchURL(): void {
    const hasOptellumLaunchPermission: boolean = this.authService.doesUserHasPermission(PermissionSchemaConstants.getPermissionSchema('optellumContextLaunch'));
    if (hasOptellumLaunchPermission) {
      this.permitOptellumContextLaunch$ = this.workflow.checkIfPerformer().pipe(map(val => val));
      this.optellumInfo = this.workflow.getOptellumConfigurationInfo();
      this.optellumURL$ = this.timelineService.getOptellumServerUrl();
      const getAdditionalOptellumConfiguration$ = this.timelineService.getAdditionalOptellumConfiguration();
      this.hasAppNameAndCtInfo$ = getAdditionalOptellumConfiguration$.pipe(map(data => data.modalityList.includes(this.optellumInfo['modality']) && data.appList.includes(this.optellumInfo['appName'])))
      this.optellumButtonLabel$ = getAdditionalOptellumConfiguration$.pipe(map(data => data.buttonLabel));
    }
  }

  /**
   * On click of Optellum button it will launch Optellum dashboard
   */
  launchOptellum(){
    this.optellumURL$.subscribe(url => {
      this.timelineService.launchOptellumURL(url, this.optellumInfo);
    });
  }

  showImageGallery(action, data, galleryType) {
    this._modalLoader.popupModal(PlaceholderModalComponent, PlaceholderModalLoaderPayload.builder()
      .setComponentToLoad(GalleryViewerComponent)
      .setTitle(`${action.popupTitle} - ${get(this.data, 'category.display')} ${moment(get(this.data, 'date')).format('ll')}`)
      .setCssClasses('fixed-size-modal-container ')
      .setPayload({ ...data, selectedEvent: this.payload.data, galleryType}), ModalTypes.CUSTOM);

  }


  goToState(redirectUrl, param = { }) {
    const interpolatedParamsFromUrl = this._interpolateService.interpolate(redirectUrl, param);
    const redirectUrlState = this._routerManagerService.urlToState(interpolatedParamsFromUrl);
    this.router.navigate([redirectUrlState.name]);
  }

  beforeClose(_modalResponse?: modalResponse): void | ICloseReturnType {
    return undefined;
  }
}
